import React, { Suspense, ReactElement, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";

import { deviceSize } from "utils/devices";
import { Provider } from "react-redux";
import store from "redux/store";
import { graphqlClient, startServices } from "services";

import Navigation from "./components/Navigation/index";
import ErrorToast from "components/Toast/ErrorToast";
import LoginModal from "components/Auth/LoginModal";
import ResourceViewer from "components/ResourceViewer";

// asyncronously lazy import
const Resources = React.lazy(() => import("./pages/Resources/index"));
const AcsOutlines = React.lazy(() => import("./pages/AcsOutlines"));
const Profile = React.lazy(() => import("./pages/Profile"));

const defaultTheme: Object = {
  primary: "#343E49",
  secondary: "#63A0DB",
  tertiary: "#C0CCDA",
};

interface Props {
  children: ReactElement;
}

const CombineProviders: React.FC<Props> = ({ children }) => {
  return (
    <Provider store={store}>
      <ApolloProvider client={graphqlClient}>
        <ThemeProvider theme={defaultTheme}>
          <Router>{children}</Router>
        </ThemeProvider>
      </ApolloProvider>
    </Provider>
  );
};

const App: React.FC = () => {
  // auth lifecycle: restore/refresh the stored session, persist changes,
  // reset the GraphQL cache when the user changes, sync across tabs
  useEffect(() => startServices(), []);

  return (
    <div data-testid="app">
      <CombineProviders>
        <>
          <Container>
            <Navigation />
            <Switch>
              <Suspense fallback={<span></span>}>
                <Route
                  exact
                  path={["/", "/search/:search_string"]}
                  component={Resources}
                />
                <Route path="/acs-outlines" component={AcsOutlines} />
                <Route path="/profile" component={Profile} />
              </Suspense>
            </Switch>
          </Container>
          <ResourceViewer />
          <ErrorToast />
          <LoginModal />
        </>
      </CombineProviders>
    </div>
  );
};

const Container = styled.div`
  margin: auto;
  max-width: ${deviceSize.laptopL};
`;

export default App;
